//组合子模块，导出store实例

import { configureStore } from "@reduxjs/toolkit";
import unitReducer from './modules/unitStore';
import userReducer from "./modules/userStore";
import areaReducer from "./modules/areaStore";
import timerReducer from "./modules/timerStore"

const sotre=configureStore({
    reducer:{
        unit:unitReducer,
        user:userReducer,
        area:areaReducer,
        timer:timerReducer
    }
})

export default sotre